webpackJsonp([70144966829960],{

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ListItem = exports.LinkList = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"], ["\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-right: 1em;\n"], ["\n  margin-right: 1em;\n"]);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var LinkList = _styledComponents2.default.ul(_templateObject);
	
	var ListItem = _styledComponents2.default.li(_templateObject2);
	
	exports.LinkList = LinkList;
	exports.ListItem = ListItem;

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"], ["\n  padding: 0 1em;\n  max-width: 30em;\n  line-height: 1.6;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose([""], [""]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ExternalLink = __webpack_require__(57);
	
	var _ExternalLink2 = _interopRequireDefault(_ExternalLink);
	
	var _LinkList = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      Contents,
	      null,
	      _react2.default.createElement(
	        H1,
	        null,
	        "Contact"
	      ),
	      _react2.default.createElement(
	        Text,
	        null,
	        "Hi \uD83D\uDC4B\uD83C\uDFFC, feel free to contact me somewhere on the web or via mail: post @\xA0[this website]"
	      ),
	      _react2.default.createElement(
	        _LinkList.LinkList,
	        null,
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://github.com/jurekbarth" },
	            "Github"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://codepen.io/jurekbarth/" },
	            "Codepen"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.xing.com/profile/Jurek_Barth" },
	            "Xing"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.linkedin.com/in/jurekbarth/" },
	            "LinkedIn"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://twitter.com/jurekbarth" },
	            "Twitter"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.facebook.com/jurek.barth" },
	            "Facebook"
	          )
	        ),
	        _react2.default.createElement(
	          _LinkList.ListItem,
	          null,
	          _react2.default.createElement(
	            _ExternalLink2.default,
	            { href: "https://www.instagram.com/jurekbarth/" },
	            "Instagram"
	          )
	        )
	      )
	    )
	  );
	};
	
	var Contents = _styledComponents2.default.div(_templateObject);
	
	var H1 = _styledComponents2.default.h1(_templateObject2);
	
	var Text = _styledComponents2.default.p(_templateObject3);
	
	exports.default = Contact;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-a78404d4a529a8dc048a.js